"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Lights_1 = __importDefault(require("./Lights"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var WheelSections_1 = __importDefault(require("./WheelSections"));
var Roulette = function (_a) {
    var wheelSections = _a.wheelSections, _b = _a.isPromo, isPromo = _b === void 0 ? false : _b;
    return (react_1.default.createElement("div", { className: "".concat(isPromo ? styles_module_scss_1.default.promoWheel : '', " ").concat(styles_module_scss_1.default.container) },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.goldSection }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
            react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.prizesContainer, " wheelFortunePrizes") },
                react_1.default.createElement(WheelSections_1.default, { wheelSections: wheelSections })),
            react_1.default.createElement(Lights_1.default, null),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.lens }),
            react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.pivot) }))));
};
exports.default = Roulette;
